export default {
  text: {
    fontSize: 14,
    paddingBottom: 8,
    wordBreak: 'break-all',
    whiteSpace: 'pre-line',
  },
}



// WEBPACK FOOTER //
// ./src/Components/Chat/ChatMessage/contents/ChatText/styles.js